export enum PrintingAspectRatioTypes {
  ThreeTwo = 1,
  TwoThree = 2,
  OneOne = 3,
}
